// src/core/constants.ts

export const WHT_RATE = 0.20;

export const LOAN_STATUS = {
    DRAFT: 'DRAFT',
    ACTIVE: 'ACTIVE',
    FUNDED: 'FUNDED',
    FINISHED: 'FINISHED',
    EXTENDED: 'EXTENDED',
    DEFAULTED: 'DEFAULTED',
} as const;

export const TICKET_STATUS = {
    OPEN: 'OPEN',
    ANSWERED: 'ANSWERED',
    RESOLVED: 'RESOLVED'
} as const;

export const LOAN_LEDGER_ENTRY_TYPE = {
    CLIENT_FUNDS_IN: 'CLIENT_FUNDS_IN',
    PLATFORM_FUNDS_IN: 'PLATFORM_FUNDS_IN',
    BORROWER_PAYMENT_IN: 'BORROWER_PAYMENT_IN', // Borrower payments (interest/capital) - NOT counted in funding percentage
    MANUAL_ADJUSTMENT: 'MANUAL_ADJUSTMENT',
    CLIENT_PAYOUT: 'CLIENT_PAYOUT',
    PLATFORM_FUNDS_OUT: 'PLATFORM_FUNDS_OUT',
    PRINCIPAL_INCREASE: 'PRINCIPAL_INCREASE',
    PRINCIPAL_DECREASE: 'PRINCIPAL_DECREASE',
    WHT_LIABILITY: 'WHT_LIABILITY',
    INTEREST_DISTRIBUTION: 'INTEREST_DISTRIBUTION',
    INTEREST_HELD: 'INTEREST_HELD'
} as const;


export const BORROWER_LEDGER_ENTRY_TYPE = {
    DRAWDOWN: 'DRAWDOWN',
    FEE_CHARGED: 'FEE_CHARGED',
    INTEREST_PAYMENT: 'INTEREST_PAYMENT',
    CAPITAL_REPAYMENT: 'CAPITAL_REPAYMENT',
    FEE_PAYMENT: 'FEE_PAYMENT',
    INTEREST_ROLL_UP: 'INTEREST_ROLL_UP',
    NON_UTILISATION_FEE: 'NON_UTILISATION_FEE',
    SCHEDULE_COMMENT: 'SCHEDULE_COMMENT'
} as const;
